module.exports = __webpack_public_path__ + "img/img_quick_e.0c9ddadb.jpg";